const files = require.context('.', false, /\.js$/);
const modules = {};

const importAll = function(files) {
  files.keys().forEach((file) => {
    if (file !== './index.js') {
      let fileName = file.replace(/(\.\/|\.js)/g, '');
      modules[fileName] = files(file).default;
    }
  });

  return modules;
};

export default importAll(files);
